import {Component} from "@angular/core";
import {ManufacturerSearchModel} from "../manufacturer-search.model";
import {ManufacturerEntityModel} from "../manufacturer-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-manufacturer-search-page",
    templateUrl: "./manufacturer-search-page.component.html",
    providers: [provideSearchModel(ManufacturerSearchModel), provideEntityModel(ManufacturerEntityModel)]
})
export class ManufacturerSearchPageComponent extends AbstractSearchPage {

}
